import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-invoice-dialog-history',
  templateUrl: './invoice-dialog-history.component.html',
  styleUrls: ['./invoice-dialog-history.component.css']
})
export class InvoiceDialogHistoryComponent implements OnInit {
  invoice: any;
  invoices: any;
  credit_debit: any;
  adjustments: any;
  isChecked = false;
  showDiscount = false;
  public discountForm: UntypedFormGroup;
  credt_debtJson: any;
  credt_debtDetls: any;
  hideCreditDebt = true;
  licenseDiscountType: any[] = [];
  configData: any;
  licenseDiscounts: any;
  bothdiscounts: any = [];
  api_error: any;
  api_success: string;
  licenseDetails: any = {};
  show = false;
  discountDetailsTxt;
  addonDetails: any;
  btndisabled = false;
  gstNumber: any;
  showPreviousDue = false;
  previousStatements: any = {
    addonDetailsArray: [],
    licensePkgDetailsArray: [],
    creditDeditArray: []
  };
  latestInvoiceDiscount: any = [];
  hideLicense = true;
  licenseSubscriptionDiscount: any = [];
  adhocDiscount: any = [];
  previousInvoiceRefNumber: any = [];
  margeinvoice: any = [];
  discounts: any = [];
  discount_detail;
  discount_value;
  mergedref;
  statemntview;
  callvalue;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: number,
    private accountService: AccountService, private commonService: CommonfilterService,
    private formbuilder: UntypedFormBuilder) {
    this.createForm();
    this.commonService.getConfigData()
      .subscribe(res => {
        this.configData = res;
        this.licenseDiscountType = this.configData.licenseDiscTypes;
      });
  }
  formErrors = {
    'name': '',
    'calculationType': '',
    'description': '',
    'discountValue': ''

  };
  ValidationMessages = {
    'name': {
      'required': 'DiscountName is required',

    },
    'calculationType': {
      'required': 'DiscountType is required'
    },
    'description': {
      'required': 'Description is required'
    },
    'discountValue': {
      'required': 'DiscountValue is required'
    }
  }

  ngOnInit() {
     this.getInvoiceDetails();
    this.accountService.getGSTNumber()
      .subscribe(res => {
        this.gstNumber = res;
      });
  }
  createForm() {
    this.discountForm = this.formbuilder.group({
      name: ['', Validators.required],
      discountValue: ['', Validators.required],
      calculationType: ['Fixed'],
      description: ['', Validators.required]

    });
  }
  checkPreviousStatements(mergedStatements) {
    if (mergedStatements.statements.length !== 0) {
      mergedStatements.statements.forEach(object => {
        if (object.addonDetails) {
          object.addonDetails.forEach(addon => {
            if (object.discountTotal) {
              addon['discountTotal'] = object.discountTotal;
            }
            this.previousStatements.addonDetailsArray.push(addon);
          });
        }
        if (object.discount) {
          const licenseDiscounts = JSON.parse(object.discount);
          licenseDiscounts.discount.forEach(discountObj => {
            this.discounts.push(discountObj);
          });
        }
        if (object.licensePkgDetails) {
          if (object.discountTotal) {
            object.licensePkgDetails['discountTotal'] = object.discountTotal;
          }
          this.previousStatements.licensePkgDetailsArray.push(object.licensePkgDetails);
        }
        if (object.creditDebitJson) {
          const credit_debit = JSON.parse(object.creditDebitJson);
          credit_debit.creditDebitDetails.forEach(creditDebtObj => {
          this.previousStatements.creditDeditArray.push(creditDebtObj);
          });
        }
        if (object.mergedStatements !== null) {
          this.checkPreviousStatements(object.mergedStatements);
        }

      });
      console.log('creditDEbitArray........' + this.previousStatements.creditDebitArray);
      console.log('creditDEbitArray........' + JSON.stringify(this.previousStatements.creditDebitArray));

    }

  }
  getInvoiceDetails() {
    this.adhocDiscount = [];
    this.bothdiscounts = [];
    this.discounts = [];
    this.latestInvoiceDiscount = [];
    this.licenseSubscriptionDiscount = [];
    this.accountService.getpaymentuuid(this.data)
    .subscribe(res => {
      this.invoices = res;
      // console.log(this.invoices);
    });
    this.accountService.getInvoice(this.data)
    .subscribe(res => {
      this.invoice = res;
      // console.log(this.invoice);
      for (let i in this.invoice) {
        this.callvalue = this.invoice[i];} 
      // console.log('invoice......' + JSON.stringify(this.invoice));
      if (this.invoice.licensePkgDetails) {
        this.hideLicense = false;
        this.licenseDetails = this.invoice.licensePkgDetails;
      }
      if (this.invoice.addonDetails) {
        this.addonDetails = this.invoice.addonDetails;
      }
      if (this.invoice.creditDebitJson) {
        this.hideCreditDebt = false;
        this.credt_debtJson = JSON.parse(this.invoice.creditDebitJson);
        this.credt_debtDetls = this.credt_debtJson.creditDebitDetails;
        this.credit_debit = JSON.parse(this.invoice.creditDebitJson);
        this.adjustments = this.credit_debit.creditDebitDetails;
      }
      if (this.invoice.discount) {
        // this.licenseDiscounts = JSON.parse(this.invoice.discount);
        this.licenseDiscounts = this.invoice.discount;
        this.licenseDiscounts.discount.forEach(discountObj => {

          if (discountObj.discountType === 'Predefined') {
           this.licenseSubscriptionDiscount.push(discountObj);
          } else if (discountObj.discountType === 'OnDemand') {
           this.adhocDiscount.push(discountObj);
          }
          this.bothdiscounts.push(discountObj);
         // this.latestInvoiceDiscount.push(discountObj);
          // this.discounts.push(discountObj);
        });
      }
      // if (this.invoice.mergedStatements) {
      //   this.checkPreviousStatements(this.invoice.mergedStatements);
      //   console.log('old statements.........' + JSON.stringify(this.previousStatements));
      //   console.log('discounts.....' + JSON.stringify(this.discounts));
      // }
         if (this.invoice.mergedStatements) {
           this.getPreviousInvoiceRefNumber(this.invoice.mergedStatements);
        // this.checkPreviousStatements(this.invoice.mergedStatements);
       // console.log('old statements.........' + JSON.stringify(this.previousStatements));
        // console.log('discounts.....' + JSON.stringify(this.discounts));
       }

    });
   
  }
  getPreviousInvoiceRefNumber(mergedStatements) {
    if (mergedStatements.statements.length !== 0) {
      mergedStatements.statements.forEach(object => {
        this.previousInvoiceRefNumber = object.invoiceRefNumber;
        // console.log(this.previousInvoiceRefNumber.toString());
        return ;
      });
      }
  }
margeStatement(invoiceRefNumber) {
  this.showPreviousDue = !this.showPreviousDue;
  this.accountService.mergeStmt(invoiceRefNumber)
  .subscribe(res => {
       this.margeinvoice = res;
    // console.log(this.margeinvoice);
    // this.margeinvoice = res;
    // this.margeinvoice.forEach(merge_refno => {
    //  this.mergedref = merge_refno;
    //  console.log(this.mergedref);
    // });
 
    this.api_success = '';
    setTimeout(() => {
      this.api_success = '';
      this.discountForm.reset();
        }, 1000);
  },
    (error) => {
      this.btndisabled = false;
      this.api_error = error.error;
    });
}
  checkValue(event: any) {
    if (event) {
      this.showDiscount = true;
    } else {
      this.showDiscount = false;

    }
  }
  // confirmDiscount() {
  //   const account_uuid = this.invoice.ynwUuid;
  //   const dialogRef = this.dialog.open(ConfirmDiscountComponent, {
  //     width: '600px',
  //     // tslint:disable-next-line:max-line-length
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     this.onDiscountApply();
  //   });
  // }
}
